import { render, staticRenderFns } from "./UBProfileDetail.vue?vue&type=template&id=0cf3a317"
import script from "./UBProfileDetail.vue?vue&type=script&lang=js"
export * from "./UBProfileDetail.vue?vue&type=script&lang=js"
import style0 from "./UBProfileDetail.vue?vue&type=style&index=0&id=0cf3a317&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports